import React from 'react';
import api from 'lib/trpcClient';
import { useLayoutContext } from 'contexts/LayoutContext';
import {
  createEqualisationEditorRoute,
  EQUALISATIONS_ADD,
} from 'adminConstants/routes';
import { Edit, Delete, SyncAlt } from '@mui/icons-material';
import useHandleTrpcMutation from 'hooks/ui/useHandleTrpcMutation';
import Page from 'components/new/Page';
import Table, { Column as TableColumn } from 'further-ui/components/Table';

const EqualisationsContent: React.FC = () => {
  const { vehicle } = useLayoutContext();
  const [equalisationsData] = api.equalisations.list.useSuspenseQuery({
    vehicleId: vehicle?._id ?? '',
  });

  const mutationOpts = useHandleTrpcMutation<{
    success: boolean;
  }>();

  const deleteEqualisation = api.equalisations.delete.useMutation(
    mutationOpts({
      successMessage: 'Equalisation deleted successfully',
    }),
  );

  const equalisations = equalisationsData?.results ?? [];

  const columns: Array<TableColumn<(typeof equalisations)[number]>> = [
    {
      key: 'name',
      label: 'Equalisation name',
      render: (row) => row.name,
    },
    {
      key: 'closeDate',
      label: 'Close date',
      render: (row) => row.closeDate.toReadable(),
    },
  ];

  return (
    <Table
      actions={[
        {
          label: 'Edit',
          icon: Edit,
          link: (row) => createEqualisationEditorRoute(row.id ?? ''),
          hidden: (row) => !row.isDraft,
        },
        {
          label: 'Delete',
          icon: Delete,
          onClick: (row) =>
            deleteEqualisation.mutate({
              equalisationId: row.id ?? '',
              vehicleId: vehicle?._id ?? '',
            }),
          hidden: (row) => !row.canBeDeleted || deleteEqualisation.isPending,
        },
      ]}
      columns={columns}
      rows={equalisations}
    />
  );
};

const Equalisations: React.FC = () => {
  return (
    <Page
      actions={[
        {
          label: 'Add new',
          variant: 'contained',
          link: EQUALISATIONS_ADD,
        },
      ]}
      headingIcon={SyncAlt}
      spacing="md"
      heading="Equalisations"
      withHeadingDivider
    >
      <EqualisationsContent />
    </Page>
  );
};

export default Equalisations;
